import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import Box from "@mui/material/Box";
import { getTrendClassName } from "../utils/trends.js";
const iconSizes = {
  xs: {
    fontSize: "0.8rem",
    diameter: "1.1rem"
  },
  sm: {
    fontSize: "1rem",
    diameter: "1.4rem"
  },
  md: {
    fontSize: "1.4rem",
    diameter: "1.8rem"
  },
  lg: {
    fontSize: "1.6rem",
    diameter: "2rem"
  },
  xl: {
    fontSize: "2rem",
    diameter: "2.4rem"
  }
};
const iconSizeMixin = (iconSizes2) => {
  const iconClasses = {};
  Object.entries(iconSizes2).forEach(([size, {
    diameter,
    fontSize
  }]) => {
    iconClasses[`&.${size}`] = {
      height: diameter,
      width: diameter,
      borderRadius: fontSize,
      "& .MuiSvgIcon-root": {
        fontSize
      }
    };
  });
  return iconClasses;
};
const IconWrapper = styled(Box)(({
  theme
}) => ({
  alignContent: "center",
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  ...iconSizeMixin(iconSizes),
  ["& .MuiSvgIcon-root.trend-neutral"]: {
    color: theme.colors.text.primary
  },
  ["&.trend-neutral"]: {
    color: theme.colors.text.primary
  },
  ["& .MuiSvgIcon-root.trend-positive"]: {
    color: theme.colors.text["trend-up"]
  },
  ["&.trend-positive"]: {
    backgroundColor: "#E6F0E3"
    // todo, move functional colors to theme
  },
  ["& .MuiSvgIcon-root.trend-negative"]: {
    color: theme.colors.text["trend-down"]
  },
  ["&.trend-negative"]: {
    backgroundColor: "#FCE3E1"
  }
}));
const TrendIcon = (t0) => {
  const $ = c(17);
  const {
    direction,
    desiredTrend,
    size: t1
  } = t0;
  const size = t1 === void 0 ? "sm" : t1;
  const t2 = direction ?? 0;
  const t3 = desiredTrend ?? "positive";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = getTrendClassName(t2, t3);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const directionClass = t4;
  const t5 = `icon-wrapper ${directionClass} ${size}`;
  let t6;
  if ($[3] !== direction || $[4] !== directionClass) {
    t6 = direction === 1 && /* @__PURE__ */ jsx(ArrowUpwardIcon, { className: directionClass });
    $[3] = direction;
    $[4] = directionClass;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== direction || $[7] !== directionClass) {
    t7 = direction === 0 && /* @__PURE__ */ jsx(RemoveCircleIcon, { className: directionClass });
    $[6] = direction;
    $[7] = directionClass;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== direction || $[10] !== directionClass) {
    t8 = direction === 2 && /* @__PURE__ */ jsx(ArrowDownwardIcon, { className: directionClass });
    $[9] = direction;
    $[10] = directionClass;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== t8) {
    t9 = /* @__PURE__ */ jsxs(IconWrapper, { className: t5, children: [
      t6,
      t7,
      t8
    ] });
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
export {
  TrendIcon as default
};
